import React, { useState } from 'react';
import axios from 'axios';
import { Alert, Spinner } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart, faLock } from '@fortawesome/free-solid-svg-icons';

const DonationSection = () => {
    const [donationType, setDonationType] = useState('one-off');
    const [amount, setAmount] = useState(50);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();

        const parsed = parseInt(amount, 10);
        if (!Number.isInteger(parsed) || parsed < 10 || parsed > 10000 || String(parsed) !== String(amount).trim()) {
            setError('Please enter a whole MYR amount between 10 and 10,000.');
            return;
        }

        setLoading(true);
        setError('');

        try {
            const response = await axios.post('/api/donations/create-checkout-session', {
                amount: parsed,
                donationType,
            });
            window.location.href = response.data.url;
        } catch {
            setError('Something went wrong. Please try again or contact admin@fobk.org');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div id="donate" className="donation-section__strip">
            <div className="donation-section__inner">
                <div className="donation-section__copy">
                    <FontAwesomeIcon icon={faHeart} className="donation-section__heart" />
                    <div>
                        <h2 className="donation-section__title">Support FoBK</h2>
                        <p className="donation-section__subtitle">Donate any amount you like. Every contribution is warmly welcomed.</p>
                    </div>
                </div>

                <form onSubmit={handleSubmit} className="donation-section__form" noValidate>
                    <div className="donation-section__toggle-row">
                        <button
                            type="button"
                            className={`donation-section__toggle${donationType === 'one-off' ? ' donation-section__toggle--active' : ''}`}
                            onClick={() => { setDonationType('one-off'); setAmount(50); }}
                        >
                            One-off
                        </button>
                        <button
                            type="button"
                            className={`donation-section__toggle${donationType === 'recurring' ? ' donation-section__toggle--active' : ''}`}
                            onClick={() => { setDonationType('recurring'); setAmount(25); }}
                        >
                            Monthly
                        </button>
                    </div>

                    <input
                        type="number"
                        className="donation-section__amount-input"
                        placeholder="MYR"
                        min={10}
                        max={10000}
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                    />

                    <button
                        type="submit"
                        className="donation-section__submit-btn"
                        disabled={loading}
                    >
                        {loading ? (
                            <>
                                <Spinner size="sm" />
                                Processing…
                            </>
                        ) : (
                            'Donate Now'
                        )}
                    </button>

                    <p className="donation-section__trust">
                        <FontAwesomeIcon icon={faLock} className="donation-section__lock-icon" />
                        Secure via Stripe
                    </p>
                </form>
            </div>

            {error && (
                <div className="donation-section__error-row">
                    <Alert color="danger" className="donation-section__error">{error}</Alert>
                </div>
            )}
        </div>
    );
};

export default DonationSection;
